export const companyName = "Neurocentro Veterinario";
export const agendarUrl =
  "https://wa.me/56939013512?text=Hola,%20quisiera%20solicitar%20informaci%C3%B3n%20por%20favor";
